const LessonPuppetSteps = [
  { // step 0 - intro
    size : "ROW",
    name: "general.intro",
    description: "course.theatre.lesson-puppet.description",
    AnimalName : "koala",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_intro.jpg",
    id:"puppet_intro",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_intro_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.intro.videoURL_01",
        videoThumbnail: "/assets/course/theatre/intro-thumbnail.jpg",
        isStepGoal: true,
        isSkippable: true,
        notMandatory: true
      }
    ]
  },
  { // todays lesson
    buttonShape: "circle",
    size : "coinImg",
    name: "teamworkSkills.wheel-of-creativity.name",
    description: "teamworkSkills.wheel-of-creativity.description",
    lesson: "teamworkSkills.wheel-of-creativity.lesson",
    coinName: "wheel-of-creativity",
    id:"wheel-of-creativity",
    legacyIds: [],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_wheel-of-creativity-poster.jpg",
    stepItems : [
      {
        id:"wheel-of-creativity_video",
        legacyIds: [],
        pageState: "video",
        url: "teamworkSkills.wheel-of-creativity.videoURL_01",
        videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_wheel-of-creativity-poster.jpg",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"wheel-of-creativity_discuss",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_wheel-of-creativity-poster.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.wheel-of-creativity.discussSubtitle",
      }
    ]
  },
  { // choose animal
    StepNumberToShow: 1,
    name: "course.theatre.lesson-puppet.steps.choose-animal.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-puppet.steps.choose-animal.description",
    requirements: [{name: "activityPage"}, {name: "scissors"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_choose-animal.jpg",
    id:"puppet_choose-animal",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_choose-animal_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.choose-animal.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"puppet_choose-animal_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-puppet.steps.choose-animal.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-puppet.steps.choose-animal.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_choose-animal_01.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.choose-animal.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_choose-animal_02.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.choose-animal.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_choose-animal_03.jpg"
          }
        ],
        tips: ["course.theatre.lesson-puppet.steps.choose-animal.tips.tip1"]
      }
    ]
  },
  { // glue on cardboard
    StepNumberToShow: 2,
    name: "course.theatre.lesson-puppet.steps.glue-on-cardboard.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-puppet.steps.glue-on-cardboard.description",
    requirements: [{name: "cereal"}, {name: "stick-glue"}, {name: "scissors"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_glue-on-cardboard.jpg",
    id:"puppet_glue-on-cardboard",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_glue-on-cardboard_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.glue-on-cardboard.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"puppet_glue-on-cardboard_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-puppet.steps.glue-on-cardboard.videoURL_01",
        bullets: [
          {
            text: "course.generalSteps.cut-cardboard-light",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/general_cut-cardboard-light.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.glue-on-cardboard.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_glue-on-cardboard_02_cash-fix.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.glue-on-cardboard.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_glue-on-cardboard_03_cash-fix.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.glue-on-cardboard.bullets.bullet4",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_glue-on-cardboard_04_cash-fix.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.glue-on-cardboard.bullets.bullet5",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_glue-on-cardboard_05_cash-fix.jpg"
          }
        ],
        tips: ["course.generalTips.cut-cardboard-light", "course.theatre.lesson-puppet.steps.glue-on-cardboard.tips.tip2"]
      }
    ]
  },
  { // cut the shape
    StepNumberToShow: 3,
    name: "course.theatre.lesson-puppet.steps.cut-the-shape.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-puppet.steps.cut-the-shape.description",
    requirements: [{name: "scissors"}],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_cut-the-shape.jpg",
    id:"puppet_cut-the-shape",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_cut-the-shape_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.cut-the-shape.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"puppet_cut-the-shape_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-puppet.steps.cut-the-shape.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-puppet.steps.cut-the-shape.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_01.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.cut-the-shape.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_02.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.cut-the-shape.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_03.jpg"
          }
        ],
      }
    ]
  },
  { // glue it on a stick
    StepNumberToShow: 4,
    name: "course.theatre.lesson-puppet.steps.stick.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-puppet.steps.stick.description",
    requirements: [{name: "stick"}, {name: "bottle-glue"}, {name: "tape"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_glue-on-stick.jpg",
    id:"puppet_glue-on-stick",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_glue-on-stick_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.stick.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"puppet_glue-on-stick_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-puppet.steps.stick.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.theatre.lesson-puppet.steps.stick.bullets.bullet1",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_01.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.stick.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_02.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.stick.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_03.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.stick.bullets.bullet4",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_stick_04.jpg"
          },
        ],
        tips: ["course.theatre.lesson-puppet.steps.stick.tips.tip1", "course.theatre.lesson-puppet.steps.stick.tips.tip2", "course.theatre.lesson-puppet.steps.stick.tips.tip3"]
      }
    ]
  },
  { // color
    StepNumberToShow: 5,
    name: "course.theatre.lesson-puppet.steps.color.name",
    size : "S",
    state: "disabled",
    description: "course.theatre.lesson-puppet.steps.color.description",
    requirements: [{name: "allColors"} ],
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/thumb_puupet_color.jpg",
    id:"puppet_color",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_color_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.color.videoURL_01",
        isStepGoal: true,
        isSkippable: true
      },
      {
        id:"puppet_color_teamwork",
        legacyIds: [],
        pageState: "teamWork",
        url: "course.theatre.lesson-puppet.steps.color.videoURL_01",
        string: "teamwork text here",
        bullets: [
          {
            text: "course.generalSteps.all-colors",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/general_all-colors.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.color.bullets.bullet2",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_color_02.jpg"
          },
          {
            text: "course.theatre.lesson-puppet.steps.color.bullets.bullet3",
            img: "https://media.catbears.com/course_theatre/teamwork-steps/puppet_color_03.jpg"
          }
        ],
        tips: ["course.theatre.lesson-puppet.steps.color.tips.tip1", "course.theatre.lesson-puppet.steps.color.tips.tip2"]
      }
    ]
  },
  { // trophy
    name: "finishStep.name",
    size : "CUSTOM-IMG",
    state: "disabled",
    ImageToShow: "/assets/icons/icon_trophy.svg",
    videoThumbnail: "/assets/course/theatre/videos-and-thumbnails/trophy-thumbnail.png",
    id:"puppet_trophy",
    legacyIds: [],
    stepItems : [
      {
        id:"puppet_trophy_recap_wheel-of-creativity",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/videos-and-thumbnails/thumb_wheel-of-creativity-poster.jpg",
        discussTitle: "general.whoKnows",
        discussSubtitle: "teamworkSkills.wheel-of-creativity.discussSubtitle",
      },
      {
        id:"puppet_trophy_cleanup",
        legacyIds: [],
        pageState: "discuss",
        img: "/assets/course/theatre/puppet_cleanup.png",
        discussTitle: "cleanup.title",
        discussSubtitle: "cleanup.description"
      },
      {
        id:"dance_puppet_video",
        legacyIds: [],
        pageState: "video",
        url: "course.theatre.lesson-puppet.steps.step6.videoURL_01",
        isSkippable: true,
        isStepGoal: true
      },
    ]
  }
]

export default LessonPuppetSteps;
